import { useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import ActiveGamesAiAPI from 'dashboard/api/activeGamesAi';
import { CAPTAIN_ERROR_TYPES } from 'dashboard/composables/captain/constants';

export function useActiveGamesAi() {
  const currentChat = useMapGetter('getSelectedChat');
  const { t } = useI18n();

  const errorType = error => {
    if (
      error.name === CAPTAIN_ERROR_TYPES.ABORT_ERROR ||
      error.name === CAPTAIN_ERROR_TYPES.CANCELED_ERROR
    ) {
      return CAPTAIN_ERROR_TYPES.ABORTED;
    }
    return error.response?.status
      ? `${CAPTAIN_ERROR_TYPES.HTTP_PREFIX}${error.response.status}`
      : CAPTAIN_ERROR_TYPES.API_ERROR;
  };

  const request = async (payload, signal) => {
    try {
      const { data } = await ActiveGamesAiAPI.suggest(
        currentChat.value.id,
        payload,
        signal
      );
      return {
        message: data.message,
        followUpContext: data.follow_up_context,
      };
    } catch (error) {
      if (errorType(error) !== CAPTAIN_ERROR_TYPES.ABORTED) {
        useAlert(
          error.response?.data?.error || t('ACTIVE_GAMES_HUB.AI.UNAVAILABLE')
        );
      }
      return { message: '', errorType: errorType(error) };
    }
  };

  const processEvent = (action = 'improve', content = '', options = {}) =>
    request({ action, content }, options.signal);

  const followUp = ({ followUpContext, message, signal }) =>
    request(
      {
        action: 'follow_up',
        message,
        follow_up_context: followUpContext,
      },
      signal
    );

  return {
    currentChat,
    processEvent,
    followUp,
  };
}
